import { render, staticRenderFns } from "./LotteryList.vue?vue&type=template&id=47e0df74&"
import script from "./LotteryList.vue?vue&type=script&lang=js&"
export * from "./LotteryList.vue?vue&type=script&lang=js&"
import style0 from "./LotteryList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports